/**
 * PageIntroduction functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class PageIntroduction {
  /**
   * Constructs a new PageIntroduction instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.header = this.element.querySelector('header')
    this.mainNav = document.querySelector('[data-component="main-nav"]')
    this.mediaQuery =  window.matchMedia( "(min-width: 48em)")

    // // Set initial width of header element on page load

    // if (this.mediaQuery.matches) {
    //   var mainNavWidth = this.mainNav.offsetWidth
    //   this.header.style.width = mainNavWidth + 'px'
    // }

    // window.addEventListener('resize', () => {
    //   if (this.mediaQuery.matches) {
    //     var mainNavWidth = this.mainNav.offsetWidth
    //     this.header.style.width = mainNavWidth + 'px'
    //   } else {
    //     this.header.style.width = 'auto'
    //   }
    // })

  }
}



// WEBPACK FOOTER //
// ./components/page-introduction/index.js